import type { ReactNode } from "react";

type EnrollmentLoadingOverlayProps = {
  title?: ReactNode;
  description?: ReactNode;
};

export default function EnrollmentLoadingOverlay({
  title,
  description,
}: EnrollmentLoadingOverlayProps) {
  if (!title && !description) return null;

  return (
    <>
      <div className="fixed inset-0 z-10 h-full w-full bg-black/30 data-[state=open]:animate-overlayShow" />
      <div className="pos-enrollment-loading fixed bottom-20 right-4 z-20 flex items-center gap-3 rounded-lg bg-neutral-900/90 p-4 shadow-lg md:bottom-8 md:right-8 md:gap-4 md:p-6">
        <div className="relative">
          <div className="absolute -inset-0.5 animate-ping rounded-full bg-primary-500 opacity-75" />
          <div className="relative size-3 rounded-full bg-primary-500" />
        </div>
        <div className="space-y-0.5">
          {title && (
            <p className="text-base font-medium text-neutral-0">{title}</p>
          )}
          {description && (
            <p className="text-sm text-neutral-300">{description}</p>
          )}
        </div>
      </div>
    </>
  );
}
